export const DownloadLink = {
  appStore: process.env.REACT_APP_APPLE_STORE_LINK || '',
  googlePlay: process.env.REACT_APP_GOOGLE_PLAY_LINK || '',
};
